import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=130a0c52&"
import script from "./hot.vue?vue&type=script&lang=js&"
export * from "./hot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports